/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount';
import { useSupervisionMenuCountStore } from '../../../../app/core/state-management/states/supervisionMenuCount';
import { apiCaller } from '../../../../app/core/hooks/useApi';
import { ServiceAgent } from '../../../../app/core/services/serviceAgent';
import { useEffect } from 'react';
import { useWroteStore } from '../../../../app/core/state-management/states/wrote';
import { useCardtableStore } from '../../../../app/core/state-management/states/cardtable/index2';
import { useAuth } from '../../../../app/modules/auth';
import { isValidRole, RoleNameEnum } from '../../../../app/core/utils/util';
import { FaCircle } from "react-icons/fa";

export function AsideMenuMain() {
  const intl = useIntl();

  const { userInfo } = useAuth();

  const { dispatch, state } = useMenuCountStore();
  const { dispatch: dispatchSupervisionMenuCount, state: steteSupervisionMenuCount } = useSupervisionMenuCountStore();
  const { state: worteState } = useWroteStore();
  const { state: cardtableState } = useCardtableStore();

  ///states
  const { menuCountInfo } = state;
  const { menuCountInfo: supervisionMenuCountInfo } = steteSupervisionMenuCount;
  const { WroteList } = worteState
  const { CardTableList, RequestData } = cardtableState;

  ////handler
  const getMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.cardtable.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }
  const getSupervisionMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.supervision.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatchSupervisionMenuCount({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }
  const getNotifications = () => {
    apiCaller({
      api: ServiceAgent.notifications.request_getAll,
      apiArguments: {
        CurrentPage: 1,
        PageSize: 5,
      },
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { allNotifications: resp?.data?.data?.data },
            type: 'SET_NOTIFICATION_DATA'
          })
        }
      },
    })
  }

  useEffect(() => {
    getMenuCountData()
    getSupervisionMenuCountData()
    getNotifications()
  }, [WroteList, CardTableList, RequestData])


  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) && (
          <AsideMenuItemWithSub to='/cardboard' title='کارتابل' icon='document'>
            <AsideMenuItem to='/getall-cardtable-list/1' title={'تسهیلات خط اعتباری' + ' ' + menuCountInfo?.khatEtebari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/2' title={'تسهیلات منابع داخلی' + ' ' + menuCountInfo?.manabeDakheli || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/3' title={'ضمانت نامه' + ' ' + menuCountInfo?.zemanatName || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/4' title={'تسهیلات کارگزاری' + ' ' + menuCountInfo?.karqozari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/5' title={'سرمایه گذاری' + ' ' + menuCountInfo?.khatarpazir || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-cardtable-list/6' title={'همه کارتابل ها' + ' ' + menuCountInfo?.allCardBoard || '0'} hasBullet={true} />
            <AsideMenuItem to='/cardtable-waiting-list' title={'لیست انتظار' + ' ' + menuCountInfo?.weitingList || '0'} hasBullet={true} />
            <AsideMenuItem to='/cardtable-archive-list' title={'بایگانی' + ' ' + menuCountInfo?.archiveBox || '0'} hasBullet={true} />
          </AsideMenuItemWithSub>
        )
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) && (
          <AsideMenuItemWithSub to='/supervision' title='بخش نظارت' icon='eye'>
            <AsideMenuItem to='/getall-supervision-list/1' title={'تسهیلات خط اعتباری' + ' ' + supervisionMenuCountInfo?.khatEtebari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-supervision-list/2' title={'تسهیلات منابع داخلی' + ' ' + supervisionMenuCountInfo?.manabeDakheli || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-supervision-list/3' title={'ضمانت نامه' + ' ' + supervisionMenuCountInfo?.zemanatName || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-supervision-list/4' title={'تسهیلات کارگزاری' + ' ' + supervisionMenuCountInfo?.karqozari || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-supervision-list/5' title={'سرمایه گذاری' + ' ' + supervisionMenuCountInfo?.khatarpazir || '0'} hasBullet={true} />
            <AsideMenuItem to='/getall-supervision-list/6' title={'همه ' + ' ' + (supervisionMenuCountInfo?.allCardBoard !== null ? (supervisionMenuCountInfo?.allCardBoard || '0') : '0')} hasBullet={true} />
            {/* <AsideMenuItem to='/supervision-waiting-list' title={'لیست انتظار' + ' ' + supervisionMenuCountInfo?.weitingList || '0'} hasBullet={true} />
            <AsideMenuItem to='/supervision-archive-list' title={'بایگانی' + ' ' + supervisionMenuCountInfo?.archiveBox || '0'} hasBullet={true} /> */}
          </AsideMenuItemWithSub>
        )
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/management-letter' title={
          <div className='d-flex align-items-center'>
            <span>
              {`اتوماسیون`}
            </span>
            {
              (Number(menuCountInfo?.myLetterNotSeen) > 0 && Number(menuCountInfo?.myLetterNotSeen)) &&
              <div className='d-flex align-items-center gap-1'>
                <FaCircle fontSize={11} className='text-danger-glow2 blink ms-2' />
                <span>
                  {Number(menuCountInfo?.myLetterNotSeen)}
                </span>
              </div>
            }
          </div>
        } icon='update-file'>
          <AsideMenuItem to='/management-letter' title={'مدیریت اتوماسیون' + ' ' + menuCountInfo?.myLetter || '0'} hasBullet={true} />
        </AsideMenuItemWithSub>
      }

       {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/management-letter' title={
          <div className='d-flex align-items-center'>
            <span>
              {`وصول مطالبات`}
            </span>
         
          </div>
        } icon='update-file'>
          <AsideMenuItem to='/demands-list' title={'همه مطالبات'} hasBullet={true} />
          <AsideMenuItem to='/my-work-demands-list' title={'کارهای من'} hasBullet={true} />
        </AsideMenuItemWithSub>
      }


      <AsideMenuItemWithSub to='/reminder' title='رونوشت ها' icon='notepad-bookmark'>
        <AsideMenuItem to='/wrote' title={'همه رونوشت ها ' + menuCountInfo?.transcript} hasBullet={true} />
        <AsideMenuItem to='/trans-letter' title={'همه رونوشت های نامه ' + (menuCountInfo?.letterTranscript || '0')} hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>کاربردی</span>
        </div>
      </div>
      <AsideMenuItemWithSub to='/request' title='لیست همه درخواست ها' icon='update-file'>
        <AsideMenuItem to='/all-request/1' title='در جریان' hasBullet={true} />
        <AsideMenuItem to='/all-request/2' title='تکمیل شده' hasBullet={true} />
        <AsideMenuItem to='/all-request/3' title='عودت داده شده' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to='/supervision' title='لیست همه نظارت ها' icon='update-file'>
        <AsideMenuItem to='/all-supervision/1' title='در جریان' hasBullet={true} />
        <AsideMenuItem to='/all-supervision/2' title='تکمیل شده' hasBullet={true} />
        <AsideMenuItem to='/all-supervision/3' title='عودت داده شده' hasBullet={true} />
      </AsideMenuItemWithSub>
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/letter' icon='message-question' title='لیست تمامی نامه ها' />
      }
      {
        userInfo && (isValidRole(userInfo?.userRoles || [], RoleNameEnum.Admin) || isValidRole(userInfo?.userRoles || [], RoleNameEnum.Official)) &&
        <AsideMenuItemWithSub to='/personel' title='پرسنل' icon='profile-circle'>
          <AsideMenuItem to='/personel-list' title='مدیریت پرسنل' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/survey' title='پرسش و پاسخ' icon='question'>
          <AsideMenuItem to='/survey-category' title='ایجاد برگه نظرسنجی' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub title='مالی' icon='wallet'>
          <AsideMenuItem to='/all-transaction' title='همه تراکنش ها' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/custom-text' icon='text' title='متن های پیشنهادی' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/tickets' icon='user' title='پشتیبانی' />
      }
      {/* {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/archived-document' icon='paper-clip' title='بایگانی نامه' />
      } */}
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/plans' icon='dollar' title='مدیریت اشتراک ها' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/request-form' icon='send' title='فرم درخواست' />
      }
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/support-video' icon='google-play' title='ویدئو های آموزشی' />
      }
      <AsideMenuItem to='/reports-navigate' icon='chart' title='گزارشات' />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItem to='/faq' icon='questionnaire-tablet' title='سوالات متداول' />
      }
      <AsideMenuItem to='/user-list' icon='user-tick' title='لیست کاربران' />
      {
        userInfo && !isValidRole(userInfo?.userRoles || [], RoleNameEnum.Board) &&
        <AsideMenuItemWithSub to='/setting' title='تنظیمات' icon='setting-2'>
          <AsideMenuItem to='/setting-managment' title='تنظیمات CRM' hasBullet={true} />
        </AsideMenuItemWithSub>
      }
    </>
  )
}

